export default __webpack_public_path__ + "static/media/active.7a95bb91.svg";